import {
  AdminAppErrorData,
  CustomerAction
} from '@dadohr/shared/domainTypes/internalAlerts';
import { CF } from '@dadohr/shared/versions';
import { callFirebaseFunction } from '../firebaseFunctions';

export const tryReportCustomerAction = async (action: CustomerAction) => {
  try {
    callFirebaseFunction(CF.internalAlerts.reportCustomerAction, {
      action
    });
  } catch (e) {
    console.error('ERROR REPORTING CUSTOMER ACTION', e);
  }
};

export const tryReportAdminAppError = async (data: AdminAppErrorData) => {
  try {
    console.log('calling internalAlerts-reportAdminAppError');
    callFirebaseFunction('internalAlerts-reportAdminAppError', data);
  } catch (e) {
    console.error('ERROR REPORTING ADMIN APP ERROR', e);
  }
};
